<div class="contacts-page">

  <!-- ─── HEADER ─── -->
  <div class="contacts-header">
    <div class="contacts-heading">
      <div class="contacts-heading-icon">
        <i class="fas fa-address-book"></i>
      </div>
      <div>
        <h1 class="contacts-title">{{ 'CONTACTS.TITLE' | translate }}</h1>
        <p class="contacts-subtitle">{{ 'CONTACTS.SUBTITLE' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- ─── INFO CARDS ─── -->
  <div class="contacts-grid">

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--phone">
        <i class="fas fa-phone"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'CONTACTS.CARDS.PHONE.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'CONTACTS.CARDS.PHONE.DESCRIPTION' | translate }}</span>
      </div>
    </div>

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--email">
        <i class="fas fa-envelope"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'CONTACTS.CARDS.EMAIL.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'CONTACTS.CARDS.EMAIL.DESCRIPTION' | translate }}</span>
      </div>
    </div>

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--address">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'CONTACTS.CARDS.ADDRESS.TITLE' | translate }}</span>
        <span class="contact-value">Centro Logistico Bertani, Via dell'industria, 10, 37060 Sona (VR)</span>
      </div>
    </div>

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--hours">
        <i class="fas fa-clock"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'CONTACTS.CARDS.WORKING_HOURS.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'CONTACTS.CARDS.WORKING_HOURS.DESCRIPTION' | translate }}</span>
      </div>
    </div>

  </div>

  <!-- ─── MAP CARD ─── -->
  <div class="map-card">
    <div class="map-preview">
      <iframe
        class="map-iframe"
        src="https://www.google.com/maps?q=45.438466043331076,10.860019676227324&output=embed&hl=it&z=16"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>
    <div class="map-footer">
      <div class="contact-card-icon contact-icon--map">
        <i class="fas fa-map-location-dot"></i>
      </div>
      <div class="map-footer-text">
        <span class="contact-label">{{ 'CONTACTS.CARDS.MAP.TITLE' | translate }}</span>
        <span class="contact-value">Centro Logistico Bertani – Via dell’industria, 10 – 37060 Sona (VR)</span>
      </div>
      <a class="map-open-btn"
         href="https://www.google.com/maps/search/?api=1&query=45.438466043331076,10.860019676227324"
         target="_blank"
         rel="noopener noreferrer">
        <i class="fas fa-up-right-from-square"></i>
        Apri in Maps
      </a>
    </div>
  </div>

</div>
